import {Record} from 'immutable';

const IconSettings = Record({
  id: null,
  link: null,
  cssPrefix: null,
  autoA11y: true,
  asyncLoading: true,
  largerIconSizes: true,
  fixedWidthIcons: true,
  listIcons: true,
  borderedPulledIcons: true,
  spinningIcons: true,
  rotatedFlippedIcons: true,
  stackedIcons: true,
});

export default IconSettings;



// WEBPACK FOOTER //
// ./app/javascript/records/IconSettings.js